<!-- <nb-layout>

  <nb-layout-header fixed>
 Insert header here
  </nb-layout-header>

  <nb-layout-column>


  </nb-layout-column>

  <nb-layout-footer fixed>
 Insert footer here
  </nb-layout-footer>

</nb-layout> -->
<router-outlet></router-outlet>
